import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTwooComponent } from './simple-icons-twoo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTwooComponent ],
    exports:      [ SimpleIconsTwooComponent ],
    bootstrap:    []
})
export class SimpleIconsTwooModule {}
